"use strict";
/*
 * Created on 4. 11. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link SelloutReleaseCategoryPreview}.</p>
 *
 * @author Radek Beran
 */


var SelloutReleaseCategoryPreviewConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutReleaseCategoryPreviewConverter, _DataObjectConverter_);

  function SelloutReleaseCategoryPreviewConverter() {
    _classCallCheck(this, SelloutReleaseCategoryPreviewConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseCategoryPreviewConverter).apply(this, arguments));
  }

  return SelloutReleaseCategoryPreviewConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutReleaseCategoryPreviewConverter = SelloutReleaseCategoryPreviewConverter;